document.addEventListener('DOMContentLoaded', function() {
  new VideoBackgrounds('[data-youtube]');
});
tarteaucitronForceLanguage = document.getElementsByTagName('html')[0].getAttribute('lang').substring(0,2) || 'fr';
tarteaucitronForceExpire = 183;

var privacyUrl = 'https://marine.wichard.com/fr/protection-des-donnees-personnelles';
var cookiesUrl = 'https://marine.wichard.com/fr/protection-des-donnees-personnelles';

tarteaucitronCustomText = {
  'fr': {
    "alertBigPrivacy": "<h2>Le respect de votre vie privée est notre priorité</h2> La société Wichard, responsable de traitement, utilise des cookies sur son site internet permettant une mesure d'audience : notre site utilise des cookies pour analyser votre navigation et lui permettre de mesurer l'audience et la fréquentation.<br/>En cas de refus de certains cookies, votre expérience sur notre site pourrait être altérée. Vous pourrez à tout moment modifier vos préférences ou retirer votre consentement en vous rendant dans la section <a href=\"#rgpd\">\"Gestion des cookies\"</a> en bas de page du site. Pour en savoir plus sur notre politique en matière de cookies, consultez notre <a href=\"" + cookiesUrl + "\">\"Politique de Cookies\".</a>",

    "acceptAll": "OK, tout accepter",

    "disclaimer": "En autorisant ces services tiers, vous acceptez le dépôt et la lecture de cookies et l'utilisation de technologies de suivi nécessaires à leur bon fonctionnement. Pour en savoir plus sur notre politique en matière de cookies, consultez notre politique de Cookies.<br/><br/><button type=\"button\" id=\"tarteaucitronCookieUrlDialog\" onclick=\"document.location = '" + cookiesUrl + "'\">Politique de cookies</button>",

    "allowAll": "Autoriser tous les cookies",
    "denyAll": "Interdire tous les cookies",
  }
}[tarteaucitronForceLanguage] || {};

tarteaucitron.init({
  'privacyUrl': privacyUrl,

  'hashtag': '#rgpd',
  'cookieName': 'rgpd',

  'orientation': 'middle',
  'showAlertSmall': false,
  'showIcon': false,
  'cookieslist': true,

  'adblocker': false,
  'AcceptAllCta': true,
  'highPrivacy': true,
  'handleBrowserDNTRequest': false,

  'removeCredit': true,
  'moreInfoLink': true,
  'useExternalCss': true,

  'readmoreLink': cookiesUrl,
});

tarteaucitron.job = tarteaucitron.job || [];

// Google Analytics
tarteaucitron.user.gtagUa = 'G-Y5E57KV8MJ';
tarteaucitron.job.push('gtag');